import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiUpload } from 'react-icons/fi';
import { profilePictureUpload } from '../../../../services/operations/profileApi';
import { toast } from 'react-hot-toast';
import UpdateUserDetails from './UpdateUserDetails';
import UpdatePassword from './UpdatePassword';
import DeleteAccount from './DeleteAccount';

const ProfileSettings = () => {
  const { user, loading } = useSelector((state) => state.profile);
  const [dp, setDp] = useState(user?.image);
  const dispatch = useDispatch();
  const dpHandler = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileReader = new FileReader();

      fileReader.onload = () => {
        setDp(fileReader.result);
      };

      fileReader.readAsDataURL(selectedFile);
    }
  };

  const dpUploadHandler = () => {
    try {
      const formData = new FormData();
      formData.append('profilePicture', document.getElementById('userDp').files[0]);
      dispatch(profilePictureUpload(formData));
    } catch (error) {
      toast.error('Profile Picture Upload Failed');
    }
  };

  return (
    <div className='text-richblack-5'>
      <h1 className='text-3xl font-medium'>Edit Profile</h1>
      <section
        className='mt-10 bg-richblack-800 user-dp-updation-section rounded-xl mb-7 border border-richblack-700 p-8 flex items-center gap-x-5 gap-y-3'
      >
        <img
          src={dp}
          loading='lazy'
          alt={user?.firstName}
          className='aspect-square w-[78px] rounded-full object-cover'
        />
        <div className='flex flex-col gap-y-3'>
          <p className='font-semibold'>Change Profile Picture</p>
          <label className='flex user-dp-updation-button gap-y-3 gap-x-3'>
            <p className='rounded-md bg-richblack-700 cursor-pointer py-[8px] px-[25px] font-semibold text-richblack-100'>
              Select
            </p>
            <input
              type='file'
              name='userDp'
              accept='image/*'
              id='userDp'
              className='hidden'
              onChange={dpHandler}
            />
            <button
              onClick={dpUploadHandler}
              className='flex items-center bg-yellow-50 cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-richblack-900'
            >
              <span>{loading ? 'Uploading...' : 'Upload'}</span>
              {!loading && <FiUpload />}
            </button>
          </label>
        </div>
      </section>
      <section className=' flex items-center'>
        <UpdateUserDetails user={user} />
      </section>
      <section className='flex items-center'>
        <UpdatePassword user={user} />
      </section>
      <section>
        <DeleteAccount />
      </section>
    </div>
  );
};

export default ProfileSettings;